export const config = {
  apiUrl: process.env.REACT_APP_CLIENT_API_URL,
  s3BucketUrl: process.env.REACT_APP_CLIENT_S3_BUCKET_URL,
  inventoryS3BucketUrl: (process.env.REACT_APP_CLIENT_INVENTORY_S3_BUCKET_URL || '').trim(),
  inventoryPlaceholderUrl: (process.env.REACT_APP_INVENTORY_PLACEHOLDER_URL || '').trim(),
  inventoryPlaceholderPath: (
    process.env.REACT_APP_INVENTORY_PLACEHOLDER_PATH || 'inventory_placeholders'
  ).replace(/^\/+|\/+$/g, ''),
  assetUrl: process.env.REACT_APP_CLIENT_ASSET_URL,
  altImg: 'images/no_avatar_profile.jpg',
  baseUrl: process.env.REACT_APP_CLIENT_MAIN_URL + '/',
  altInvImg: 'images/inv_img.jpeg',
  mainUrl: process.env.REACT_APP_CLIENT_MAIN_URL,
  pusherKey: process.env.REACT_APP_CLIENT_PUSHER_KEY,
  pusherCluster: process.env.REACT_APP_CLIENT_PUSHER_CLUSTER,
  dsn: process.env.REACT_APP_CLIENT_DSN,
  navBgColor: process.env.REACT_APP_CLIENT_NAV_BG_COLOR,
  assetBrandName: process.env.REACT_APP_ASSET_BRAND_NAME,
  companyName: process.env.REACT_APP_COMPANY_NAME,
  companyNameFull: process.env.REACT_APP_COMPANY_NAME_FULL,
  companyNameAbbr: process.env.REACT_APP_COMPANY_NAME_ABBR,
  companyNameLegal: process.env.REACT_APP_COMPANY_NAME_LEGAL,
  companyNameWildland: process.env.REACT_APP_COMPANY_NAME_WILDLAND,
  companyNameSms: process.env.REACT_APP_COMPANY_NAME_SMS,
  companyAddress: process.env.REACT_APP_COMPANY_ADDRESS,
  companyPhone: process.env.REACT_APP_COMPANY_PHONE,
  companyEmail: process.env.REACT_APP_COMPANY_EMAIL,
  companyWebsite: process.env.REACT_APP_COMPANY_WEBSITE,
  companyFax: process.env.REACT_APP_COMPANY_FAX,
  companyOwnerName: process.env.REACT_APP_COMPANY_OWNER_NAME,
  showLogo: !(process.env.REACT_APP_SHOW_LOGO === 'false' || process.env.REACT_APP_SHOW_LOGO === '0'), // Defaults to true, set to 'false' or '0' to hide logo
};

/** Only http(s) absolute URLs; rejects javascript:, data:, blob:, etc. Uses URL parsing so scheme checks are canonical. */
function isSafeHttpOrHttpsAbsoluteUrl(s) {
  if (typeof s !== 'string' || s.length === 0) return false;
  if (s.includes('\0')) return false;
  try {
    const u = new URL(s);
    const p = u.protocol.toLowerCase();
    return p === 'http:' || p === 'https:';
  } catch {
    return false;
  }
}

export function inventoryPicSrc(pic) {
  if (pic == null || pic === '') return '';
  const s = String(pic).trim();
  if (s === '') return '';

  // Protocol-relative URLs are unsafe in img/src when combined with bases or origins.
  if (s.startsWith('//')) return '';

  if (/^[a-z][a-z0-9+.-]*:/i.test(s)) {
    return isSafeHttpOrHttpsAbsoluteUrl(s) ? s : '';
  }

  const path = s.replace(/^\//, '');
  const placeholderBase = (config.inventoryPlaceholderUrl || '').replace(/\/*$/, '');
  const prefix = (config.inventoryPlaceholderPath || 'inventory_placeholders').replace(
    /^\/+|\/+$/g,
    '',
  );
  const pathLc = path.toLowerCase();
  const prefixLc = prefix.toLowerCase();
  if (
    placeholderBase &&
    (pathLc === prefixLc || pathLc.startsWith(prefixLc + '/'))
  ) {
    const afterPrefix =
      pathLc === prefixLc ? '' : path.slice(prefix.length + 1);
    return afterPrefix
      ? `${placeholderBase}/${prefix}/${afterPrefix}`
      : `${placeholderBase}/${prefix}`;
  }

  const override = (config.inventoryS3BucketUrl || '').trim();
  let base;
  if (override) {
    base = override.replace(/\/*$/, '/');
  } else {
    const raw = (config.s3BucketUrl || '').trim();
    const withoutLiveInventory = raw.replace(/\/live\/inventory\/?$/i, '');
    base = (withoutLiveInventory || raw).replace(/\/*$/, '/');
  }
  return base ? base + path : path;
}

export function inventoryCategoryFallbackSrc(item, { defaultSlug = "inv_img" } = {}) {
  const id =
    item?.equipment_type_id ?? item?.type_id ?? item?.equipmentTypeId ?? null;

  let slug = "";
  if (Number(id) === 1) {
    slug = "vehicle";
  } else {
    const rawType = String(item?.type || "").trim().toLowerCase();
    const normalized = rawType
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "");
    const aliases = {
      vehicles: "vehicle",
      vehicle: "vehicle",
      chain_saw: "chainsaw",
    };
    slug = aliases[normalized] || normalized || defaultSlug;
  }

  const folder = (config.inventoryPlaceholderPath || "inventory_placeholders")
    .replace(/^\/+|\/+$/g, "");
  return inventoryPicSrc(`${folder}/${slug}.jpg`);
}

/** Resolves inventory `pic` URL; treats avatar paths as missing so category placeholder is used. */
export function inventoryDisplayPicSrc(item, opts = {}) {
  const fallback = inventoryCategoryFallbackSrc(item, opts);
  const rawPic = String(item?.pic || "").trim();
  if (!rawPic) return fallback;

  const normalizedPic = rawPic.replace(/^\/+/, "").toLowerCase();
  const avatarPath = String(config.altImg || "")
    .replace(/^\/+/, "")
    .toLowerCase();
  if (
    normalizedPic.includes("no_avatar_profile") ||
    (avatarPath &&
      (normalizedPic === avatarPath ||
        normalizedPic.endsWith("/" + avatarPath)))
  ) {
    return fallback;
  }

  return inventoryPicSrc(rawPic);
}
